import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';

// The OTP-info cache that this resolver previously held has moved to
// OtpSessionService (token-based). The resolver remains as a no-op so the
// existing route declaration keeps working without touching every consumer.
@Injectable({ providedIn: 'root' })
export class shipmentResolver implements Resolve<null> {
  resolve(): Observable<null> {
    return of(null);
  }
}
